import { CreateProposalState } from './CreateProposalState.types';

export const actionTypes = {
    SAVE_DATA: 'SAVE_DATA',
    SET_SELECTED_PRODUCT_ID: 'SET_SELECTED_PRODUCT_ID',
    SET_CONNECTION_GROUP_ID: 'SET_CONNECTION_GROUP_ID',
    SET_SELECTED_PROPOSAL_OWNER: 'SET_SELECTED_PROPOSAL_OWNER',
    SET_AGENT_INFORMATION: 'SET_AGENT_INFORMATION',
    SET_SELECTED_LANGUAGE: 'SET_SELECTED_LANGUAGE',
};

type Action = { type: any; payload?: any };

export const CreateProposalReducer = (state: CreateProposalState, action: Action): CreateProposalState => {
    switch (action.type) {
        case actionTypes.SAVE_DATA:
            return { ...state, ...action.payload };
        case actionTypes.SET_SELECTED_PRODUCT_ID:
            return { ...state, selectedProductId: action.payload };
        case actionTypes.SET_CONNECTION_GROUP_ID:
            return { ...state, connectionGroupId: action.payload };
        case actionTypes.SET_SELECTED_PROPOSAL_OWNER:
            return { ...state, selectedProposalOwner: action.payload };
        case actionTypes.SET_AGENT_INFORMATION:
            return { ...state, agentInformation: action.payload };
        case actionTypes.SET_SELECTED_LANGUAGE:
            return { ...state, selectedLanguage: action.payload };
        default:
            return state;
    }
};
